module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/error-circle-d9bc0277ef68560ebc1f891b54baf3e9.svg";